var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ruoli-mantra" },
    _vm._l(_vm.Constants.RUOLI_MANTRA, function (mantraObj, mantra_id) {
      return _c("ruolo-mantra", {
        key: mantra_id,
        attrs: {
          "mantra-id": mantra_id,
          outlined: !_vm.selectedRuoliMantra.includes(mantra_id),
        },
        on: { click: _vm.toggleRuoloMantra },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }